//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    show: { // 是否显示dialog
      type: Boolean,
      default: false
    },
    src:{ // 需要预览的图片链接
      type: String
    }
  },
  methods: {
    close(e){
      // 触发关闭更新show属性
      this.$emit('update:show', false)
      // 抛出close方法
      this.$emit('close', e)
    }
  }
}
